import SigliveServiceV1 from 'Service/sigliveServiceV1';

const getRulesetDetail = async (id) => {
  const { data } = await SigliveServiceV1({ method: 'GET', url: `/schedule-ruleset/${id}` });

  return data?.data;
};

export default getRulesetDetail;
